export enum UIErrorStatus {
  Unknown = 0,
  Displayed,
  Issue
}
